<template>
  <div class="experimentList">
    <div class="experimentList-title">
      <el-input
        placeholder="请输入内容"
        prefix-icon="el-icon-search"
        v-model="params.name"
        @blur="getExperimentList"
        @keyup.native.enter="getExperimentList"
      >
      </el-input>
      <el-button
        type="primary"
        v-if="!loading"
        icon="el-icon-circle-plus-outline"
        @click="goNextRouter('/addExperiment')"
        >添加实验</el-button
      >
    </div>
    <div class="experimentList-content" v-if="!isTourist"> 
      <el-table :data="experimentList" style="width: 100%" v-loading="loading">
        <el-table-column label="封面图片">
          <template slot-scope="scope">
            <img
              :src="scope.row.cover"
              alt=""
              style="width: 146px; height: 88px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="实验名称"></el-table-column>
        <el-table-column prop="tagName" label="学科"> </el-table-column>
        <el-table-column prop="createName" label="负责人"></el-table-column>
        <el-table-column label="是否公开" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isPublic"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="publishExperiment(scope.row)"
              :disabled="
                !(scope.row.createId == userInfo.userId || userInfo.role == 2)
              "
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column width="300">
          <template slot="header">
            <span class="fontSizeCenter">操作</span>
          </template>
          <p class="operation" slot-scope="scope">
            <span
              @click="goNextRouter(`/experimentListDetail?id=${scope.row.id}`)"
              >详情</span
            ><i>|</i
            ><span @click="goNextRouter(`/queryResults?id=${scope.row.id}`)"
              >成绩</span
            ><i>|</i
            ><span
              @click="goUpdate(scope.row)"
              :style="
                scope.row.createId == userInfo.userId || userInfo.role == 2
                  ? 'color:#1880fa'
                  : 'color:#999;cursor: not-allowed;'
              "
              >编辑</span
            ><i>|</i
            ><span
              @click="deleteExperiment(scope.row)"
              :style="
                scope.row.createId == userInfo.userId || userInfo.role == 2
                  ? 'color:#1880fa'
                  : 'color:#999;cursor: not-allowed;'
              "
              >删除</span
            >
          </p>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[6, 10, 20, 30, 40]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalItems"
      >
      </el-pagination>
    </div>
    <noDate v-else :tip="'暂无实验'" style="padding:220px 0;"></noDate>
  </div>
</template>

<script>
import noDate from "@/components/common/noData.vue";
export default {
  name: "VirtualimitationIndex",
  components: {
    noDate,
  },
  data() {
    return {
      currentPage: 1,
      experimentList: [],
      params: {
        collegeId: 0,
        level: 0,
        name: "",
        pageIndex: 1,
        showItem: 6,
        status: 0,
        tagId: 0,
      },
      totalItems: 0,
      loading: true,
      timer: false,
      timerFlag: false,
      isTourist: false, //是否是游客
      userInfo: {},
    };
  },

  mounted() {
    // this.params.collegeId = JSON.parse( localStorage.getItem("USER")).collegeId; 由于接口响应时间不定问题，无法第一时间获取到collegeId字段的值
    this.userInfo = JSON.parse(localStorage.getItem("USER"));
    if (!this.userInfo) {
      this.$message({
        message: "您还未登录,请先登录！",
        type: "warning",
      });
      this.isTourist = true;
      return;
    }
    this.timer = setInterval(() => {
      if (this.timerFlag) {
        clearInterval(this.timer);
        this.timer = null;
        return;
      }
      if (!JSON.parse(localStorage.getItem("USER")).type) {
        this.isTourist = true;
      }
      if (this.userInfo && JSON.parse(localStorage.getItem("USER")).collegeId) {
        this.getExperimentList();
        this.loading = false;
        this.timerFlag = true;
        this.isTourist = false;
      }
    }, 500);
  },
  beforeDestroy() {
    this.timerFlag = true;
  },

  methods: {
    //公开实验
    publishExperiment(row) {
      let params = {
        id: row.id,
        status: row.isPublic ? 1 : 0,
      };
      this.$api.experiment.publishExperiment(params).then((res) => {
        if (res.errCode == 0) {
          this.getExperimentList();
        }
      });
    },
    //删除实验
    deleteExperiment(row) {
      if (row.createId != this.userInfo.userId && this.userInfo.role != 2) {
        return;
      }
      this.$api.experiment.deleteExperiment(row.id).then((res) => {
        if (res.errCode == 0) {
          this.$message({
            message: "刪除成功",
            type: "success",
          });
          this.getExperimentList();
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    //去编辑
    goUpdate(row) {
      if (row.createId != this.userInfo.userId && this.userInfo.role != 2) {
        return;
      }
      this.$router.push({ path: "/addExperiment", query: { id: row.id } });
    },
    // 获取本校实验列表
    getExperimentList() {
      // this.params.collegeId = JSON.parse(
      //   localStorage.getItem("USER")
      // ).collegeId;
      this.params.name = this.params.name.trim();
      this.$api.experiment.getSchoolExperimentList(this.params).then((res) => {
        if (res.data != null && res.errCode == 0) {
          this.experimentList = res.data.items;
          this.experimentList.forEach((item) => {
            item.isPublic = item.isPublic == 1 ? true : false;
          });
          this.totalItems = res.data.totalItems;
          this.loading = false;
        } else {
          this.$message.error(res.errMsg);
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.params.pageIndex = 1;
      this.params.showItem = val;
      this.getExperimentList();
    },
    //分页
    handleCurrentChange(val) {
      this.params.pageIndex = val;
      this.getExperimentList();
    },
    //跳转到下一个路由
    goNextRouter(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.experimentList {
  width: 100%;
  .experimentList-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 22px;
    .el-input {
      width: 604px;
      height: 42px;
    }
    .el-button {
      width: 112px;
      height: 42px;
    }
  }
  .experimentList-content {
    width: 100%;
    background: #fff;
    padding: 24px;
    box-sizing: border-box;
    min-height: 937px;
  }
  /deep/ .operation {
    color: #409eff;
    text-align: center;
    i {
      font-style: normal;
      margin: 0 15px;
      color: #99a7c3;
    }
    span {
      cursor: pointer;
      font-size: 14px;
      font-family: PingFang-SC;
      font-weight: 400;
      line-height: 20px;
      color: #1880fa;
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 50px;
    margin-bottom: 16px;
  }
  .el-table {
    //   padding: 24px;
    box-sizing: border-box;
  }
  .el-table /deep/ thead th .cell {
    color: #99a7c3;
  }
  .fontSizeCenter {
    display: inline-block;
    width: 100%;
    text-align: center;
  }
}
.fontSizeCenter {
  display: inline-block;
  width: 100%;
  text-align: center;
}
</style>